var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConeStarlikeSunburst = function SvgConeStarlikeSunburst(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269,
    height: 220,
    fill: "none",
    viewBox: "0 0 269 220"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF79FD",
    d: "M255.279 76.07c-8.341-6.751-8.311-19.586.063-26.382-10.592-1.62-16.93-12.726-13.022-22.813-10.007 3.943-21.012-2.449-22.62-13.137-6.736 8.446-19.462 8.48-26.159.067-1.66 10.696-12.701 17.138-22.683 13.245 3.86 10.074-2.532 21.205-13.137 22.88 8.347 6.753 8.311 19.586-.063 26.382 10.597 1.622 16.93 12.726 13.022 22.813 10.007-3.943 21.012 2.449 22.62 13.137 6.737-8.452 19.462-8.479 26.159-.067 1.66-10.696 12.7-17.137 22.683-13.245-3.86-10.074 2.532-21.205 13.137-22.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD8C8",
    d: "M47.366 67.56S13.31 132.122 9.532 139.294s15.52 13.871 47.856 9.901 49.44-15.135 44.04-21.185-54.064-60.452-54.064-60.452"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M108.683 152.177c22.242 1.854 43.301-10.3 52.817-30.494-1.855 22.242 10.304 43.302 30.494 52.817-22.242-1.855-43.302 10.304-52.817 30.494 1.854-22.242-10.3-43.301-30.494-52.817"
  })));
};
export default SvgConeStarlikeSunburst;